import 'sanitize.css'
import 'font-awesome/css/font-awesome.css'
import Vue from 'vue';
import App from './App.vue';

new Vue(App).$mount('#app')